import React from 'react';

const WidgetSettingsModal = ({ edit, t, children }) => {
  if (!edit.open) {
    return null;
  }

  return (
    <div id='modal'>
      <div
        id='popup'
        className="dashboard-modal widget-settings-modal tall"
        style={{ animationName: 'zoom' }}
      >
        <div className='dashboard-header'>
          <h2 style={{ textTransform: 'uppercase' }}>{edit.type} {t.settingsSuffix}</h2>
        </div>
        {children}
      </div>
    </div>
  );
};

export default WidgetSettingsModal;
